module.exports = __webpack_public_path__ + "img/mock-pic4.41422f8a.png";